import Mutations from '../../odata/mutations';

export default { ...new Mutations('exchangeEmail'), ...new Mutations('exchangeEmails') };
